import { NavigationGuardNext, RouteLocation, RouteLocationNormalized } from "vue-router"
import GuardianRunner from "@/router/guardian-runner"
import { ensureIsAuthenticated } from "@/router/guardians"
import { ensureCurrentPendingEnrollmentIdPresence } from "@/modules/enrollment-new/router/guardians"

export default [
  // ---- start: FLOW 2 - VPC + MEC FLOW :-------------
  {
    path: "/enroll/vpc-mec/check-insurance",
    name: "flow2-vpc-mec:check-insurance",
    beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
      GuardianRunner.run(to, from, next, [ensureIsAuthenticated, ensureCurrentPendingEnrollmentIdPresence])
    },
    component: () =>
      import("@/modules/enrollment-new/pages/flow2-vpc-mec/Step1-EnrollmentFlowInsuranceCoverageCheckPage.vue")
  },
  {
    path: "/enroll/vpc-mec/vpc-details",
    name: "flow2-vpc-mec:vpc-details",
    beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
      GuardianRunner.run(to, from, next, [ensureIsAuthenticated, ensureCurrentPendingEnrollmentIdPresence])
    },
    component: () => import("@/modules/enrollment-new/pages/flow2-vpc-mec/Step2-EnrollmentFlowVPCDetailsPage.vue")
  },
  {
    path: "/enroll/vpc-mec/confirm-account",
    name: "flow2-vpc-mec:confirm-account",
    beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
      GuardianRunner.run(to, from, next, [ensureIsAuthenticated, ensureCurrentPendingEnrollmentIdPresence])
    },
    component: () =>
      import("@/modules/enrollment-new/pages/flow2-vpc-mec/Step3-EnrollmentFlowConfirmAccountDetailsPage.vue")
  },
  {
    path: "/enroll/vpc-mec/not-covered/:reason",
    name: "flow2-vpc-mec:not-covered",
    props: true,
    beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
      GuardianRunner.run(to, from, next, [ensureIsAuthenticated, ensureCurrentPendingEnrollmentIdPresence])
    },
    component: () => import("@/modules/enrollment-new/pages/flow2-vpc-mec/Step4-EnrollmentFlowVpcNotCoveredPage.vue")
  },
  {
    path: "/enroll/vpc-mec/mec-details",
    name: "flow2-vpc-mec:mec-details",
    beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
      GuardianRunner.run(to, from, next, [ensureIsAuthenticated, ensureCurrentPendingEnrollmentIdPresence])
    },
    component: () => import("@/modules/enrollment-new/pages/flow2-vpc-mec/Step5-EnrollmentFlowMECDetailsPage.vue")
  },
  {
    path: "/enroll/vpc-mec/add-dependents",
    name: "flow2-vpc-mec:add-dependents",
    beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
      GuardianRunner.run(to, from, next, [ensureIsAuthenticated, ensureCurrentPendingEnrollmentIdPresence])
    },
    component: () => import("@/modules/enrollment-new/pages/flow2-vpc-mec/Step6-EnrollmentFlowAddDependentsPage.vue")
  },
  {
    path: "/enroll/vpc-mec/confirm-enroll",
    name: "flow2-vpc-mec:confirm-enroll",
    beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
      GuardianRunner.run(to, from, next, [ensureIsAuthenticated, ensureCurrentPendingEnrollmentIdPresence])
    },
    component: () => import("@/modules/enrollment-new/pages/flow2-vpc-mec/Step7-EnrollmentFlowConfirmEnrollPage.vue")
  },
  // ---- end: FLOW 2 - VPC + MEC FLOW :-------------

  // ---- start: FLOW 2 - VPC + MEC WAIVE FLOW :-------------
  {
    path: "/enroll/vpc-mec-waive/waive",
    name: "flow2-vpc-mec:waive",
    beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
      GuardianRunner.run(to, from, next, [ensureIsAuthenticated, ensureCurrentPendingEnrollmentIdPresence])
    },
    component: () => import("@/modules/enrollment-new/pages/flow2-vpc-mec/waive/EnrollmentWaivePage.vue")
  },
  {
    path: "/enroll/vpc-mec-waive/download-form",
    name: "flow2-vpc-mec:waive-download-form",
    props: (route: RouteLocation) => ({
      signedTermsFileUrl: route.query.signedTermsFileUrl
    }),
    beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
      GuardianRunner.run(to, from, next, [ensureIsAuthenticated])
    },
    component: () => import("@/modules/enrollment-new/pages/flow2-vpc-mec/waive/EnrollmentWaiveDownloadFormPage.vue")
  },
  {
    path: "/enroll/vpc-mec-waive/confirm-waive",
    name: "flow2-vpc-mec:waive-confirm-waive",
    beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
      GuardianRunner.run(to, from, next, [ensureIsAuthenticated, ensureCurrentPendingEnrollmentIdPresence])
    },
    component: () => import("@/modules/enrollment-new/pages/flow2-vpc-mec/waive/EnrollmentConfirmWaivePage.vue")
  },
  {
    path: "/enroll/vpc-mec-waive/survey",
    name: "flow2-vpc-mec:waive-survey",
    beforeEnter: (to: RouteLocationNormalized, from: RouteLocationNormalized, next: NavigationGuardNext) => {
      GuardianRunner.run(to, from, next, [ensureIsAuthenticated, ensureCurrentPendingEnrollmentIdPresence])
    },
    component: () => import("@/modules/enrollment-new/pages/flow2-vpc-mec/waive/EnrollmentWaiveSurveyPage.vue")
  }
  // ---- end: FLOW 2 - VPC + MEC WAIVE FLOW :-------------
]
